import axios from 'axios';
import APIManager from './APIManager';
import querystring from 'querystring'

export function get(params, url, action, extras={}) {
  // console.log(action);
  // console.log(params);
  return APIManager.getKey()
  .then(key => {
    return axios.request({
      url : process.env.API_URL + url,
      method : 'GET',
      headers: {
        "X-API-KEY" : key,
      },
      params : params,
      ...extras
    })
  })
}

export function post(params, url, action, extras={}) {
  return APIManager.getKey()
  .then(key => {
    return axios.request({
      url : process.env.API_URL + url,
      method : 'POST',
      headers: {
        "X-API-KEY" : key,
        "Content-Type" : "application/x-www-form-urlencoded"
      },
      data : querystring.stringify(params),
      ...extras
    })
  });
}

export function put(params, url, action, extras={}) {
  return APIManager.getKey()
  .then(key => {
    return axios.request({
      url : process.env.API_URL + url,
      method : 'PUT',
      headers: {
        "X-API-KEY" : key,
        "Content-Type" : "application/x-www-form-urlencoded"
      },
      data : querystring.stringify(params),
      ...extras
    })
  });
}

export function del(params, url, action, extras={}) {
  return APIManager.getKey()
  .then(key => {
    return axios.request({
      url : process.env.API_URL + url,
      method : 'DELETE',
      headers: {
        "X-API-KEY" : key,
        "Content-Type" : "application/x-www-form-urlencoded"
      },
      data : querystring.stringify(params),
      ...extras
    })
  });
}



// WEBPACK FOOTER //
// ./src/actions/REST.js